/**
 * PC_RG_01
 * Importing the component, API and packages
 */
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import './ProfileRequest.css';
import { getProfileRequest } from '../../service/PerformanceAPI';
import ProfileRequestForm from './ProfileRequestfForm';

import './ProfileRequest.css';
import moment from 'moment';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import Loader from '../../StaticComponent/Loader';
import { encryptStorage } from '../../constant';

export default function ProfileUpdate() {

    //let { state } = useLocation()

    /**
     * PC_RG_02
     * State variables are created
     */
    const [profileRequest, setProfileRequest] = useState([]);
    const [noData, setNoData] = useState(false);
    const [value, setValue] = useState(true);
    const [requestId, setRequestId] = useState();
    const [profile, setProfile] = useState(false);
    const [menuClicked, setMenuClicked] = useState('');
    const [flag, setflag] = useState(false);
    const [ToastShow, setToastShow] = useState(false);
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    const [ToastColor, setToastColor] = useState('');
    const [isLoading, setIsLoading] = useState(true);


    const [breadCrumbsData, setbreadCrumbsData] = useState([]);

    const { state } = useLocation()

    /**
     * PC_RG_03
     * useEffect is invoked andthen loadProfileRequest function is called
     */
    useEffect(() => {
        loadProfileRequest();
        // state = {profileRequestId: 228}
    }, []);
    const navigate = useNavigate();
    useEffect(() => {
        if (encryptStorage.getItem('groupid') != 1) navigate('/');
    }, []);



    useEffect(() => {
        if (state?.profileRequestId) {
            //
            setRequestId(state?.profileRequestId)
            requestClicked(state?.profileRequestId)
        }
    }, [state?.profileRequestId])

    /**
     * PC_RG_04
     * getProfileRequest function is invoked to retrieve the data
     * then response is set in state variable
     */
    const loadProfileRequest = async () => {
        if (menuClicked == '') {
            sideRequestTab('pending')
            // let profileData = {
            //     "status": "Pending"
            // }
            // let result = await getProfileRequest(profileData)
            // setProfileRequest((result.data.ResponseData != "No data found") ? (result.data.ResponseData) : [])
            // let count = ((result.data.ResponseData == "No data found") ? true : false)
            // setNoData(count)
        }
    };

    const backClicked = (value, toastValue = '') => {
        //

        setValue(value);
        sideRequestTab(menuClicked)
        if (toastValue !== '') {

            setToastShow(true)
            if (toastValue == 'success') {
                setToastValue('Successfully Approved')
                setToastPara('Request is approved')
                setToastColor('green')
            }
            else {
                setToastValue('Successfully Denied')
                setToastPara('Request is denied')
                setToastColor('Red')
            }
            setTimeout(() => {
                setToastShow(false)
            }, 2500);
        }
    };

    const requestClicked = (profileId) => {
        //
        setToastShow(false)
        setRequestId(profileId);
        setValue(false);

    };

    const sideRequestTab = async (menu) => {
        //
        setIsLoading(false)
        setValue(true)
        let profileData, requestResponse, noDataValue;
        switch (menu) {
            case "pending":
                profileData = { "status": "Pending" }
                requestResponse = await getProfileRequest(profileData)
                noDataValue = (requestResponse.data.ResponseData == "No data found") ? true : false
                setProfileRequest((requestResponse.data.ResponseData != "No data found") ? (requestResponse.data.ResponseData) : [])
                setNoData(noDataValue)
                setProfile(false)
                setflag(!flag)
                if (state?.way) {
                    setbreadCrumbsData([
                        { title: 'Dashboard', path: '/Overview?tab=activities', isActive: true },
                        { title: 'Profile Update', path: '/profileupdate', isActive: true },
                        { title: 'Pending', path: '', isActive: false },
                    ]);
                }
                else {
                    setbreadCrumbsData([
                        { title: 'Dashboard', path: '/Overview?tab=activities', isActive: true },
                        { title: 'Team Member', path: '', isActive: true },
                        { title: 'Profile Update', path: '/profileupdate', isActive: true },
                        { title: 'Pending', path: '', isActive: false },
                    ]);
                }
                break;
            case 'completed':
                profileData = { status1: 'approved', status2: 'denied' };
                requestResponse = await getProfileRequest(profileData);
                noDataValue = requestResponse.data.ResponseData == 'No data found' ? true : false;
                setProfileRequest(requestResponse.data.ResponseData.length > 0 ? requestResponse.data.ResponseData : []);
                setNoData(noDataValue);
                setProfile(true);
                setflag(!flag);

                if (state?.way) {
                    setbreadCrumbsData([
                        { title: 'Dashboard', path: '/Overview', isActive: true },
                        { title: 'Profile Update', path: '/profileupdate', isActive: true },
                        { title: 'Completed', path: '', isActive: false },
                    ]);
                }
                else {
                    setbreadCrumbsData([
                        { title: 'Dashboard', path: '/Overview', isActive: true },
                        { title: 'Team Member', path: '', isActive: true },
                        { title: 'Profile Update', path: '/profileupdate', isActive: true },
                        { title: 'Completed', path: '', isActive: false },
                    ]);

                }
                break;
        }
        setMenuClicked(menu);
        setIsLoading(true)
    };



    return (
        <>
            {ToastShow ? (
                <EvaluationPopUp Page={'Success Insert'} color={ToastColor} Heading={ToastValue} Paragraph={ToastPara} />
            ) : null}

            <div className="container-fluid mt-5">
                <div className="row">
                    <div className="col-md-12 bg-color">
                        <div className="row">
                            {/*profile update tab part starts here*/}
                            <div className="col-md-2 px-0 custom-height-tab bg-white">
                                <h5 className="font-14 tt-bold profileupdate-text-blue py-4 mt-2 mb-0 px-4">Profile Update</h5>
                                <div
                                    className="nav flex-column nav-pills px-2 mt-2"
                                    id="v-pills-tab"
                                    role="tablist"
                                    aria-orientation="vertical"
                                >
                                    <button
                                        className="nav-link rounded-0 active text-start profileupdate-text-blue pending-tab-sty font-12 semibold-text"
                                        id="pending-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pending"
                                        type="button"
                                        role="tab"
                                        aria-controls="pending"
                                        aria-selected="true"
                                        onClick={() => {
                                            sideRequestTab('pending');
                                        }}
                                    >
                                        <span>
                                            <img src="/Images/pending.svg" alt="pending" className="pe-2 pending-icon-sty" />
                                        </span>
                                        Pending
                                    </button>
                                    <button
                                        className="nav-link rounded-0 text-start profileupdate-text-blue pending-tab-sty font-12 semibold-text"
                                        id="Completed-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#Completed"
                                        type="button"
                                        role="tab"
                                        aria-controls="Completed"
                                        aria-selected="false"
                                        onClick={() => {
                                            sideRequestTab('completed');
                                        }}
                                    >
                                        <span>
                                            <img src="/Images/completed-icon.svg" alt="pending" className="pe-2 completed-icon-sty" />
                                        </span>
                                        Completed
                                    </button>
                                </div>
                            </div>
                            {/*profile update tab part ends here*/}
                            {/*profile update right part starts here*/}
                            {isLoading ?
                                <>
                                    <div className={`col-md-10 mb-3 bg-color `}>
                                        <div className="tab-content" id="v-pills-tabContent">
                                            <div className="tabpane fade show active" id="pending" role="tabpanel" aria-labelledby="pending-tab">
                                                {value ?
                                                    <>
                                                        <div className='mt-4'>
                                                            <BreadCrumbs data={breadCrumbsData} />
                                                        </div>

                                                        <div className="row mx-2 pt-3 pb-4 px-3 bg-white">
                                                            {profile ? (
                                                                <>
                                                                    <h6 className="font-18 text-blue tt-bold"> Completed Profile Updates</h6>
                                                                    <p className='regular-text font-13 profileupdate-text-gray'>Here is the list of requests that have been reviewed and ‘Completed’. The employees have been notified about the status.</p>

                                                                </>
                                                            ) : (
                                                                <>
                                                                    <h6 className="font-18 text-blue tt-bold"> Pending Profile Updates</h6>
                                                                    <p className='regular-text font-13 profileupdate-text-gray'>Here is a list of Pending Requests raised by the employees for updating their profiles. You can review them, 'Approve' or 'Deny', and based on your actions a notification will be sent to the respective team members. </p>

                                                                </>


                                                            )}
                                                            <p className="regular-text font-13 profileupdate-text-gray"></p>
                                                            <ul className="list-group list-group-flush my-3 px-3">
                                                                {/* {requestBind()} */}
                                                                {noData ? (
                                                                    <div className="row justify-content-center">
                                                                        <img
                                                                            src="/Images/nodatafound.png"
                                                                            alt="nodatafound"
                                                                            className="nofeedbackimg-sty"
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    profileRequest.map((profile) => {

                                                                        return (
                                                                            <li className="list-group-item px-0 d-flex justify-content-between align-items-center">
                                                                                <div
                                                                                    className="d-flex align-items-center"
                                                                                    onClick={() => {
                                                                                        requestClicked(profile.id);
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src="/Images/logo-person-user-person-icon.jpg"
                                                                                        alt="Profile Picture"
                                                                                        className="candidate-profile-pic"
                                                                                    />
                                                                                    <div className="d-block ps-3 align-item-center">
                                                                                        <h1 className="font-13 mb-0 semibold-text text-blue">
                                                                                            {profile.employee_name}
                                                                                            <span className="profileupdate-text-gray ps-2">
                                                                                                {moment(profile.created_at).format('MMM DD, YYYY')}
                                                                                            </span>
                                                                                        </h1>
                                                                                        <p className=" font-13 pb-0 pt-1 profileupdate-text-gray regular-text my-0">
                                                                                            I’m requesting for {profile.category} Information Change
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <a
                                                                                    onClick={() => {
                                                                                        requestClicked(profile.id);
                                                                                    }}
                                                                                    className="text-decoration-none"
                                                                                >
                                                                                    <img src="/Images/navigate-arrow.svg" alt="Nav-icon" />
                                                                                </a>
                                                                            </li>
                                                                        );
                                                                    })
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </>
                                                    : requestId !== undefined && <ProfileRequestForm Id={requestId} Back={(value, toastValue = '') => backClicked(value, toastValue)} />
                                                }
                                            </div>

                                            {/* <div className="tab-pane fade" id="Completed" role="tabpanel" aria-labelledby="Completed-tab" /> */}
                                        </div>
                                    </div>
                                </> : <Loader isLoading={isLoading} />}

                            {/*profile update right part starts ends here*/}
                        </div>
                    </div>
                </div>
            </div> :
        </>
    );
}
